import Member from "./Member";
import dayjs, {Dayjs} from "dayjs";
import DeathMemberStatusEnum from "../enums/DeathMemberStatusEnum";
import CountryManager, {CountryLight} from "../helpers/CountryManager";
import DeathVote from "./DeathVote";

export default class DeathRequest {
    public id: string
    public photo: string
    public comment: string
    public status: DeathMemberStatusEnum
    public member: Member
    public country: CountryLight | null
    public city: string
    public contactName: string
    public contactEmail: string
    public contactPhone: string
    public contactCity: string
    public contactAddress: string
    public contactRegion: string
    public contactPostalCode: string
    public voted: boolean
    public contactCountry: CountryLight | null
    public address: string | null
    public postalCode: string
    public locationName: string | null
    public region: string
    public deathAt: string
    public createdAt: Dayjs
    public updatedAt: Dayjs
    public approvalDate: Dayjs
    public votants?: number
    public round: number
    public votes?: DeathVote[]
    public requiredDocumentsUploaded: boolean
    public editable: boolean

    constructor(data: any) {
        this.id = data.reference
        this.photo = data.photo
        this.member = new Member(data.member)
        this.status = DeathMemberStatusEnum.tryParse(data.status)
        this.country = data.country ? CountryManager.getCountryAlpha2CodeWithFlagMap(data.country) : null
        this.contactCountry = data.contactCountry ? CountryManager.getCountryAlpha2CodeWithFlagMap(data.contactCountry) : null
        this.city = data.city
        this.locationName = data.locationName
        this.contactName = data.contactName
        this.round = data.round ?? 0
        this.contactRegion = data.contactRegion
        this.contactEmail = data.contactEmail
        this.contactPhone = data.contactPhone
        this.contactAddress = data.contactAddress
        this.contactPostalCode = data.contactPostalCode
        this.contactCity = data.contactCity
        this.address = data.address
        this.voted = data.voted ?? false
        this.region = data.region
        this.comment = data.comment ?? null;
        this.postalCode = data.postalCode
        this.createdAt = dayjs(data.createdAt)
        this.updatedAt = dayjs(data.updatedAt)
        this.deathAt = data.deathAt.replace(/\s/g, '').split('T')[0]
        this.approvalDate = dayjs(data.approvalDate)
        if(data.votants) {
            this.votants = data.votants
        }
        if(data.votes) {
            this.votes = data.votes.map((v: any) => new DeathVote(v));
        }
        this.requiredDocumentsUploaded = data.requiredDocumentsUploaded ?? false
        this.editable = data.editable ?? true
    }
}
